<template>
  <component :is="icon" />
</template>

<script>
import ConnectionFail from '@/components/icons/design/ConnectionFail.vue';
import ConnectionOk from '@/components/icons/design/ConnectionOk.vue';
import Settings from '@/components/icons/design/Settings.vue';
import Home from '@/components/icons/design/Home.vue';
import HomeLg from '@/components/icons/design/HomeLg.vue';
import HamburgerMenu from '@/components/icons/design/HamburgerMenu.vue';
import Arrows from '@/components/icons/design/Arrows.vue';
import Chart from '@/components/icons/design/Chart.vue';
import Device from '@/components/icons/design/Device.vue';
import Notification from '@/components/icons/design/Notification.vue';
import Project from '@/components/icons/design/Project.vue';
import Scene from '@/components/icons/design/Scene.vue';
import SceneLg from '@/components/icons/design/SceneLg.vue';
import Support from '@/components/icons/design/Support.vue';
import Visualization from '@/components/icons/design/Visualization.vue';
import Favorite from '@/components/icons/design/Favorite.vue';
import JalousieClose from '@/components/icons/design/JalousieClose.vue';

export default {
  name: 'IcoolIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      icons: {
        'connection-fail': ConnectionFail,
        'connection-ok': ConnectionOk,
      },
    };
  },
  components: {
    ConnectionFail,
    ConnectionOk,
    Settings,
    Home,
    HamburgerMenu,
    Arrows,
    Chart,
    Device,
    Notification,
    Project,
    Scene,
    Support,
    Visualization,
    HomeLg,
    Favorite,
    SceneLg,
    JalousieClose,
  },
};
</script>

<style scoped>
</style>
